const DEFAULT_CONTENT_TYPE = "application/json";
const DEFAULT_SDK_VARIANT = "storefront-api-client";
// This is value is replaced with package.json version during rollup build process
const DEFAULT_CLIENT_VERSION = "0.2.1";
const PUBLIC_ACCESS_TOKEN_HEADER = "X-Shopify-Storefront-Access-Token";
const PRIVATE_ACCESS_TOKEN_HEADER = "Shopify-Storefront-Private-Token";
const SDK_VARIANT_HEADER = "X-SDK-Variant";
const SDK_VERSION_HEADER = "X-SDK-Version";
const SDK_VARIANT_SOURCE_HEADER = "X-SDK-Variant-Source";
const CLIENT = "Storefront API Client";

export { CLIENT, DEFAULT_CLIENT_VERSION, DEFAULT_CONTENT_TYPE, DEFAULT_SDK_VARIANT, PRIVATE_ACCESS_TOKEN_HEADER, PUBLIC_ACCESS_TOKEN_HEADER, SDK_VARIANT_HEADER, SDK_VARIANT_SOURCE_HEADER, SDK_VERSION_HEADER };
//# sourceMappingURL=constants.mjs.map
